export const DSRKafuU = {
  name: '一之濑肥波 | 宇宙和音',
  link: 'https://github.com/dsrkafuu',
};

export const j0sh77 = {
  name: 'Jimmy Lolo | Malboro',
  link: 'https://na.finalfantasyxiv.com/lodestone/character/6170027/',
};
